export default "__VITE_ASSET__tyfsz1hZ__"